// extracted by mini-css-extract-plugin
export default {"article-heading":"ResultSection_article-heading__8CwuC","result-section":"ResultSection_result-section__1yLA7","copy-message":"ResultSection_copy-message__a7MpL"};